exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "col-sm-9 col-md-9 col-lg-9 .ms-parent {\n  width: 100% !important; }\n\n#outer {\n  width: 100%;\n  text-align: center; }\n\n.inner {\n  display: inline-block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/report-filter/report-filter.component.scss
// module id = ../../../../../src/app/report/report-filter/report-filter.component.scss
// module chunks = main